// Get cart location
export const getCartResortLocation = state => state.cartResortLocation;

// Get expired cart
export const getExpiredCart = state => state.expiredCart;

// Get cart last visited step
export const getCartLastVisitedStep = state => state.cartLastVisitedStep;

export const getHandoffCartId = state => state.handoffCartId;
